/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./order-select.vue?vue&type=template&id=74dd1e60&scoped=true&"
import script from "./order-select.vue?vue&type=script&lang=ts&"
export * from "./order-select.vue?vue&type=script&lang=ts&"
import style0 from "./order-select.vue?vue&type=style&index=0&id=74dd1e60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dd1e60",
  null
  
)

export default component.exports